export const css = {
    root: 'n-6nOW8E',
    content: 'KyiXT-uk',
    title: 'NOX9CHU4',
    subtitle: '_2KySU-pq',
    actions: 'dANjl4iP',
    ' _key': 'card/practice'
};
export default css;
